import contacts from 'collections/contactsInstance';
import fetchOncePromise from 'libraries/fetchOncePromise';

export default fetchOncePromise(contacts);
